import { motion } from "framer-motion";
import { Reveal, EASE } from "./motion-primitives";
import { CtaButton } from "./CtaButton";

export const PlanTripCta = () => {
  return (
    <section id="plan" data-testid="plan-trip-section" className="bg-teal text-ink">
      <div className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10 lg:px-16">
        <Reveal>
          <span className="font-sans text-xs uppercase tracking-[0.3em] text-ink/60">
            Plan My Trip
          </span>
        </Reveal>

        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-15% 0px" }}
          className="mt-6 max-w-4xl font-serif text-5xl font-light leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-7xl"
          data-testid="plan-trip-headline"
        >
          <span className="block overflow-hidden">
            <motion.span
              className="block"
              variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
              transition={{ duration: 1, ease: EASE }}
            >
              Your trip.
            </motion.span>
          </span>
          <span className="block overflow-hidden">
            <motion.span
              className="block italic"
              variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
              transition={{ duration: 1, ease: EASE, delay: 0.12 }}
            >
              Our point of view.
            </motion.span>
          </span>
        </motion.h2>

        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl font-sans text-lg leading-relaxed text-ink/80">
            Tell us where you're going, what you love, and what you want to avoid. We'll help shape a
            trip that feels like yours.
          </p>
        </Reveal>

        <Reveal delay={0.18}>
          <div className="mt-8">
            <CtaButton testId="plan-trip-cta" variant="onTeal" to="/plan-my-trip">
              Plan My Trip
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
